import { render, staticRenderFns } from "./FormFieldDesignerDialog.vue?vue&type=template&id=0581efc9&"
import script from "./FormFieldDesignerDialog.vue?vue&type=script&lang=js&"
export * from "./FormFieldDesignerDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\UBoss\\Source\\Frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0581efc9')) {
      api.createRecord('0581efc9', component.options)
    } else {
      api.reload('0581efc9', component.options)
    }
    module.hot.accept("./FormFieldDesignerDialog.vue?vue&type=template&id=0581efc9&", function () {
      api.rerender('0581efc9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/featureOnePage/webParts/formField/FormFieldDesignerDialog.vue"
export default component.exports